import { colors } from '../sharedStyles';

export default function Services({ scrollToSection }) {
    const servicesData = [
        {
            title: 'STABILISER',
            description: 'Reprendre le contrôle de vos marges et de votre trésorerie pour décider sans tension.',
            icon: (
                <svg className="w-6 h-6" style={{ width: '1.5rem', height: '1.5rem', color: colors.white }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19.25C9.33333 19.25 7.02778 18.2361 5.33333 16.5C3.63889 14.7639 2.72222 12.5556 2.5 10H4.55C4.77259 11.9686 5.51323 13.7223 6.69755 15.1118C7.88187 16.5012 9.47957 17.25 11.25 17.25C13.0204 17.25 14.6181 16.5012 15.8025 15.1118C16.9868 13.7223 17.7274 11.9686 17.95 10H20C19.7778 12.5556 18.8611 14.7639 17.1667 16.5C15.4722 18.2361 13.1667 19.25 10.5 19.25H9.5M12 2V13M12 2L9.5 5M12 2L14.5 5M9 8H15" />
                </svg>
            ),
        },
        {
            title: 'STRUCTURER',
            description: 'Mettre en place une organisation financière solide et agile, adaptée à votre croissance.',
            icon: (
                <svg className="w-6 h-6" style={{ width: '1.5rem', height: '1.5rem', color: colors.white }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            ),
        },
        {
            title: 'DÉCIDER ET ACCÉLÉRER',
            description: 'Sécuriser vos décisions stratégiques et accompagner vos phases clés de développement.',
            icon: (
                <svg className="w-6 h-6" style={{ width: '1.5rem', height: '1.5rem', color: colors.white }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                </svg>
            ),
        },
    ];

    return (
        <section id="services" style={{ paddingTop: '6rem', paddingBottom: '6rem', backgroundColor: colors.lightBlueBg }}>
            <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '0 1.5rem' }}>
                <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
                    <h2 className="fade-in-up" style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', fontWeight: 800, color: colors.primary, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '2px' }}>
                        STABILISER, STRUCTURER, DÉCIDER
                    </h2>
                    <h3 className="fade-in-up" style={{ fontSize: '1.5rem', fontWeight: 600, color: colors.text, marginBottom: '2rem' }}>
                        3 leviers pour transformer votre fonction finance en véritable outil de pilotage
                    </h3>
                    <p className="fade-in-up" style={{ maxWidth: '48rem', margin: '0 auto', fontSize: '1.125rem', lineHeight: 1.6, color: colors.textLight }}>
                        J'interviens comme <b>DAF à temps partagé</b> pour un accompagnement récurrent, ou dans le cadre de <b>missions ciblées</b> selon vos enjeux.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
                    {servicesData.map((service, index) => (
                        <div key={index} className="service-card fade-in-up" style={{ backgroundColor: colors.white, padding: '2.5rem', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', transition: 'all 0.3s ease' }}>
                            <div style={{ width: '4rem', height: '4rem', borderRadius: '12px', backgroundColor: colors.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem' }}>
                                {service.icon}
                            </div>
                            <h4 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1rem', color: colors.primary }}>
                                {service.title}
                            </h4>
                            <p style={{ fontWeight: 400, lineHeight: 1.6, color: colors.textLight, margin: 0 }}>
                                {service.description}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="fade-in-up" style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <p style={{ fontWeight: 'bold', fontSize: '1.25rem', color: colors.primary }}>
                        Objectif : transformer la finance en outil de décision stratégique.
                    </p>
                </div>

                <div className="fade-in-up" style={{ textAlign: 'center' }}>
                    <button
                        style={{
                            backgroundColor: colors.primary,
                            color: colors.white,
                            padding: '1rem 2rem',
                            borderRadius: '50px',
                            fontWeight: 700,
                            fontSize: '1rem',
                            border: 'none',
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(20, 45, 85, 0.4)',
                            transition: 'all 0.3s ease'
                        }}
                        onClick={() => scrollToSection('contact')}
                        onMouseEnter={(e) => { e.target.style.transform = 'translateY(-3px)'; e.target.style.boxShadow = '0 8px 25px rgba(20, 45, 85, 0.5)'; }}
                        onMouseLeave={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 15px rgba(20, 45, 85, 0.4)'; }}
                    >
                        Prendre rendez-vous
                    </button>
                </div>
            </div>
        </section>
    );
}
